import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './security/auth-guard.guard';

import { LoginComponent } from './views/login/login.component';
import { Page404Component } from './views/page404/page404.component';
import { BodyComponent } from './views/body/body.component';

import { FirstPageAlunoComponent } from './views/initial/initial.component';

import { MAHomeComponent } from './views/menu-atendimento/m-a-home/m-a-home.component';
import { NovoAtendimentoComponent } from './views/menu-atendimento/m-a-home/novo-atendimento/novo-atendimento.component';
import { PesquisarComponent } from './views/menu-atendimento/m-a-home/pesquisar/pesquisar.component';
import { AgendadosComponent } from './views/menu-atendimento/m-a-home/agendados/agendados.component';
import { ResultadosComponent } from './views/menu-atendimento/m-a-home/pesquisar/resultados/resultados.component';
import { EditarResultadosComponent } from './views/menu-atendimento/m-a-home/pesquisar/resultados/editar-resultados/editar-resultados.component';
import { RegistroCompletoComponent } from './views/menu-atendimento/m-a-home/agendados/registro-completo/registro-completo.component';
import { PortalComponent } from './views/afiliado/portal/portal.component';
import { LojaComponent } from './views/afiliado/loja/loja.component';
import { AfiliacaoComponent } from './views/afiliado/afiliacao/afiliacao.component';
import { AfiliadoComponent } from './views/afiliado/afiliado.component';
import { AHomeComponent } from './views/afiliado/modulos/home/home.component';
import { MeusDadosComponent } from './views/afiliado/modulos/meus-dados/meus-dados.component';
import { DinheiroNoBolsoComponent } from './views/afiliado/modulos/dinheiro-no-bolso/dinheiro-no-bolso.component';
import { DisciplinasComponent } from './views/disciplinas/disciplinas.component';
import { AulasComponent } from './views/aulas/aulas.component';
import { SimuladosComponent } from './views/simulados/simulados.component';
import { VideosComponent } from './views/videos/videos.component';
import { CallCenterComponent } from './views/alunos/matricula-aluno/callcenter.component';
import { CartaoCreditoComponent } from './views/alunos/matricula-aluno/aluno-financeiro-contrato/matricula-caracteristicas-plano/cartao-credito/cartao-credito.component';
import { PgtoCcComponent } from './views/alunos/matricula-aluno/aluno-financeiro-contrato/matricula-caracteristicas-plano/cartao-credito/pgto-cc/pgto-cc.component';
import { PgtoOkComponent } from './views/alunos/matricula-aluno/aluno-financeiro-contrato/matricula-caracteristicas-plano/cartao-credito/pgto-ok/pgto-ok.component';
import { AcordoPagamentoPublicoComponent } from './views/acordo-pagamento-publico/acordo-pagamento-publico.component';
import { ReguaPagamentoPublicoComponent } from './views/regua-pagamento-publico/regua-pagamento-publico.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'initial', component: FirstPageAlunoComponent },
  { path: 'disciplinas', component: DisciplinasComponent },
  { path: 'simulados', component: SimuladosComponent },
  { path: 'videos', component: VideosComponent },
  { path: 'aulas', component: AulasComponent},
  { path: 'afiliado', component: AfiliadoComponent, children: [
    { path: 'portal', component: PortalComponent},
    { path: 'home', component: AHomeComponent },
    { path: 'meus-dados', component: MeusDadosComponent },
    { path: 'dinheiro-no-bolso', component: DinheiroNoBolsoComponent },
  ]},
  { path: 'afiliado/loja', component: LojaComponent},
  { path: 'afiliado/afiliacao', component: AfiliacaoComponent },
  { path: 'callCenter', component: CallCenterComponent },
  { path: 'pgto-cc', component: PgtoCcComponent },
  { path: 'pgto-ok', component: PgtoOkComponent },
  // US-001 B-006: Tela publica de pagamento do acordo (sem AuthGuard)
  { path: 'acordo/:token/pagar', component: AcordoPagamentoPublicoComponent },
  // US-005 GAP-06: Pagina publica de pagamento da regua de cobranca (sem AuthGuard)
  { path: 'pagamento/:token', component: ReguaPagamentoPublicoComponent },
  { path: 'menu-atendimento/m-a-home', component: MAHomeComponent},
  { path: 'menu-atendimento/m-a-home/novo-atendimento', component: NovoAtendimentoComponent },
  { path: 'menu-atendimento/m-a-home/pesquisar', component: PesquisarComponent },
  { path: 'menu-atendimento/m-a-home/pesquisar/resultados', component: ResultadosComponent },
  { path: 'menu-atendimento/m-a-home/pesquisar/resultados/editar-resultados', component: EditarResultadosComponent },
  { path: 'menu-atendimento/m-a-home/agendados', component: AgendadosComponent },
  { path: 'menu-atendimento/m-a-home/agendados/registro-completo', component: RegistroCompletoComponent },
  { path: '', component: BodyComponent, canActivateChild: [AuthGuard], children: [
    { path: 'gerenciador', canActivate: [AuthGuard], data: { aluno: false, menu: 'gerenciador' },
      loadChildren: () => import('./views/gerenciador/gerenciador.module').then(mod => mod.GerenciadorModule) },
    { path: 'rh', canActivate: [AuthGuard], data: { aluno: false, menu: 'rh' },
      loadChildren: () => import('./views/rh/rh.module').then(mod => mod.RhModule) },
    { path: 'portal-adm', canActivate: [AuthGuard], data: { aluno: false, menu: 'portal-adm' },
      loadChildren: () => import('./views/portal-administrativo/portal-administrativo.module').then(mod => mod.PortalAdministrativoModule) },
    { path: 'ticket', canActivate: [AuthGuard], data: { aluno: false, menu: 'ticket' },
      loadChildren: () => import('./views/ticket/ticket.module').then(mod => mod.TicketModule) },
    { path: 'metas-comissoes', canActivate: [AuthGuard], data: { aluno: false, menu: 'metas-comissoes' },
      loadChildren: () => import('./views/meta-comissoes/meta-comissoes.module').then(mod => mod.MetaComissoesModule) },
    { path: 'financeiro', canActivate: [AuthGuard], data: { aluno: false, menu: 'financeiro' },
      loadChildren: () => import('./views/financeiro/financeiro.module').then(mod => mod.FinanceiroModule) },
    { path: 'alunos', canActivate: [AuthGuard], data: { aluno: true, menu: 'alunos' },
      loadChildren: () => import('./views/alunos/alunos.module').then(mod => mod.AlunosModule) },
    { path: 'provas', canActivate: [AuthGuard], data: { aluno: false, menu: 'provas' },
      loadChildren: () => import('./views/provas/provas.module').then(mod => mod.ProvasModule) },
    { path: 'aula-online', canActivate: [AuthGuard], data: { aluno: true, menu: 'aula-online' },
      loadChildren: () => import('./views/aula-online/aula-online.module').then(mod => mod.AulaOnlineModule) },
    { path: 'relatorios', canActivate: [AuthGuard], data: { aluno: false, menu: 'relatorios' },
      loadChildren: () => import('./views/relatorios/relatorios.module').then(mod => mod.RelatioriosModule) },
    { path: 'comunicacao', canActivate: [AuthGuard], data: { aluno: false, menu: 'comunicacao' },
      loadChildren: () => import('./views/comunicacao/comunicacao.module').then(mod => mod.ComunicacaoModule) },
  ]},
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
